
@if (direction == 'Horizontal' || direction == 'Other Horizontal') {
  <casing-plan-2d-schematic-horizontal [applicationData]="applicationData" [casingPlan]="casingPlan"></casing-plan-2d-schematic-horizontal>
}

@if (direction == 'Vertical') {
  <casing-plan-2d-schematic-vertical  [applicationData]="applicationData" [casingPlan]="casingPlan"></casing-plan-2d-schematic-vertical>
}

@if (direction == 'Directional') {
  <casing-plan-2d-schematic-directional [applicationData]="applicationData" [casingPlan]="casingPlan"></casing-plan-2d-schematic-directional>
}